export const DefaultImage = [require('./default-image.jpg'), require('./default-image@2x.jpg')];
export const DefaultImageLarge = [
  require('./default-image-large.jpg'),
  require('./default-image-large@2x.jpg'),
];
